import { Divider } from '@mui/material'
import moment from 'moment';
import React from 'react'
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    nameClass: {
         //display: "flex",
         //justifyContent: "left",
         height: 48,
         width: 90,
        // width:107,
        //wordWrap: 'break-word'
        //whiteSpace: "pre-wrap" 
        overflowWrap: 'break-word',
        fontSize: "12px",
        verticalAlign:"middle",
        alignItems:"center",
        
    
    },
    regNoClass: {
        marginTop: "16px",
        color: "white",
        display: "flex",
        justifyContent: "center"
    },

    workLineClass: {
        border: "1px solid white",
        fontSize: "10px",
        position: "absolute",
        height: 50, display: "flex",
        justifyContent: "center",
        wordBreak:'break-all'
        //  apply random dynamic color---> 
        // '#' + Math.floor(Math.random() * 16777215).toString(16)
    },
    rowClass: {
        display: "flex",
        position: "relative",
        justifyContent:"center",
        verticalAlign:"middle",
        textAlign:"center"
    },
    name: {
        //paddingTop: "1 px"
        verticalAlign:"center",
        textAlign:"center"
    }
});
const getTimeDifference=(start:any, end:any)=> {
    const startTime:any = new Date(start);
    const endTime:any = new Date(end);
   
    const timeDifference = endTime - startTime;
   
    // Calculate hours, minutes, and seconds
    const hours = Math.floor(timeDifference / 3600000); // 1 hour = 3600000 milliseconds
    const remainingTime = timeDifference - hours * 3600000;
    const minutes = Math.floor(remainingTime / 60000); // 1 minute = 60000 milliseconds
    const seconds = Math.floor((remainingTime % 60000) / 1000); // 1 second = 1000 milliseconds
//    console.log(Math.floor(hours *60)+minutes+ ' minutes')
   //console.log(`${hours}h ${minutes}m ${seconds}s`)
   // return `${hours}h ${minutes}m ${seconds}s`;
   return Math.floor(hours *60)+minutes //minutes
  }
   const defaultHours= Math.floor(2 *60)

export const TechnicianWorkStatus = (props: any) => {
    const { VINnumber, name, width, index, data, ...other } = props;
    const classes = useStyles();
    let skill:any ="";
    let _data = data?.map((i: any) => {
        let item = { ...i }
        let initialTime: any = moment().format("YYYY-MM-DDT09:00:00");
            skill= i.Skill;

            let currentdate:any = moment().format("YYYY-MM-DD");
            let currentDateAndTime:any=moment().format("YYYY-MM-DDTHH:mm:ss")
            let promisedDeliveryTime:any = moment(i.PromiseDeliveryDateTime).format("YYYY-MM-DDTHH:mm:ss");

             
            const timeDifference = getTimeDifference(currentDateAndTime, promisedDeliveryTime);

//console.log("promisedDeliveryTime",props?.name, promisedDeliveryTime,timeDifference)
            let lateststartTime:any = moment(i.ScheduleStartDatetime).format("YYYY-MM-DD");
            let latestendTime:any = moment(i.ScheduleEndDatetime).format("YYYY-MM-DD");

            
            let startTime = moment(i.ScheduleStartDatetime).format("YYYY-MM-DDTHH:mm:ss");
            let endTime = moment(i.ScheduleEndDatetime).format("YYYY-MM-DDTHH:mm:ss");
          
    //  / console.log("startTime endTime",currentDateAndTime,endTime,(moment(endTime).diff(moment(currentDateAndTime), 'minutes')))
           if(currentdate === lateststartTime && currentdate === latestendTime){
            const startAndEndDateTimeDiff=(moment(endTime).diff(moment(currentDateAndTime), 'minutes'))
           // console.log("startTime endTime",currentDateAndTime,endTime,(moment(endTime).diff(moment(currentDateAndTime), 'minutes')))
          
            const diff = (moment(endTime).diff(moment(startTime), 'minutes'))
            const width = diff * 1.91
            const initialDiff = (moment(startTime).diff(moment(initialTime), 'minutes'))
            const left = initialDiff * 1.52
            item = { ...item, width, left,timeDifference,startAndEndDateTimeDiff}
           }
           else
             item={}
        //}
        return item
    })

    return (
        <div>
            <div style={{ display: "flex", backgroundColor: index % 2 == 0 ? "#EEFAFF" : "#ffffff" }}>
                <div className={classes.nameClass}>
                    <span className={classes.name}>
                    {skill} {name}
                    </span>
                </div>

                <div className={classes.rowClass}>
                    {_data?.map((i: any,index:any) =>
                        <div key={index} className={classes.workLineClass} 
                            style={{
                                left: `${i.left}px`, width: `${i.width}px`,
                                backgroundColor: i.timeDifference<defaultHours || (i.startAndEndDateTimeDiff>0&&i.startAndEndDateTimeDiff<60)?"#FF0000": "#3632FF", //blue and red
                                visibility:i.RegNo?"unset":"hidden"
                            }}
                        >
                           {/* { i.timeDifference + " "+defaultHours+" "+index % 2+" "+i.startAndEndDateTimeDiff+" "+i.startAndEndDateTimeDiff} */}
                            <span className={classes.regNoClass}>
                                {i.RegNo} 
                            </span>
                        </div>
                    )}
                </div>

            </div>
            <Divider orientation="vertical" flexItem sx={{ borderRightWidth: 1, borderColor: 'white', height: "2px" }} />

        </div>

    )
}
